import { translate as mainTranslate } from 'loankeeper-common/helpers'
import { ERR_REQUIRED_FIELD } from './constants'

export const translate = (key) => mainTranslate(`frm_account_add-${key}`)
export const translateLKMessage = (name) => mainTranslate(`LKMESSAGE-${name}`)
export const translateFrmUccPay = (key) => mainTranslate(`frm_app_add_edit-${key}`)

export function getSecLevel(SecLevel) {
  if (!SecLevel || isNaN(SecLevel) || parseInt(SecLevel) !== parseFloat(SecLevel) || parseInt(SecLevel) < 1) {
    return ERR_REQUIRED_FIELD
  }

  return undefined
}
